export default __webpack_public_path__ + "static/media/cobject1.0f4f8b03.svg";